import 'owl.carousel2/dist/assets/owl.carousel.css';
import 'owl.carousel2/dist/assets/owl.theme.default.css';
import $ from 'jquery';
import 'owl.carousel2/dist/owl.carousel';

// import './../../styles/shared/modules/latest_news.css'

((($) => {

    $('.js-latest-news-slider').owlCarousel({
        autoplay: true,
        autoplayTimeout: 4000,
        items: 1,
        rtl: true,
        nav: false,
        loop: true,
    });

})(jQuery));
